import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AddressSuggestion } from "@core/types";
import { addressClient } from "@core/clients";

type Props = {
  address: string;
  searchPrefix?: string;
  abortSignal?: AbortSignal;
};

type MutationOptions = UseMutationOptions<AddressSuggestion[] | null, unknown, Props, string[]>;

const useAddressSuggestionMutation = (options: MutationOptions = {}) => {
  return useMutation(
    ["address-suggestion"],
    async ({ address, abortSignal, searchPrefix }) => {
      if (!addressClient) throw new Error("addressClient not implemented");
      return await addressClient.getAddressSuggestion(address, abortSignal, searchPrefix);
    },
    {
      ...options,
    }
  );
};

export default useAddressSuggestionMutation;
